import { IAppState } from '../../../AppModulesWrapper';
import { IOfferGeo } from '../../types/reducers/offer';

export function selectOfferGeo(state: IAppState): IOfferGeo | undefined {
  return state.servicePickerWidget.offer.geo;
}
